import styled from "styled-components";
import type { SpaceProps } from "styled-system";
import { space } from "styled-system";
import * as NewContainer from "../../../../../../../common-deprecated/styles/lexus/Container";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

const Container = styled(NewContainer.default)<SpaceProps>`
    max-width: 100%;
    padding: 0 ${({ theme }) => (theme.noContainerSpacing ? 0 : theme.spacer)}px;
    ${space};

    @media ${getBreakpoint("up", "md")} {
        max-width: 750px;
    }

    @media ${getBreakpoint("up", "lg")} {
        max-width: 970px;
    }

    @media ${getBreakpoint("up", "xl")} {
        max-width: 1170px;
    }
`;

export default Container;
